import Container from "~/components/layout/Container"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion"
import { Icon } from "~/components/ui/icon"
import { cn } from "~/styles/utils"
const styles = {
  icon: {
    closed: "hidden icc !w-5 !h-5 mr-2",
    open: "block icm !w-4 !h-4 mr-2"
  },
  trigger: `text-[14px] font-lato font-bold text-[#444444] !flex  !items-start !justify-start text-left 
  hover:text-[#1b477f] hover:!no-underline
  [&_svg:nth-child(3)]:hidden 
  [&_svg]:text-[#1b477f] 
  [&[data-state=open]>svg.icc]:block [&[data-state=open]>svg.icm]:hidden`,
  content: "text-base font-lato font-normal text-[#777777] pl-4"
}

const MissionAccordion = () => {
  return (
    <section className="py-16 bg-white">
      <Container className="">
        <Accordion type="single" collapsible className="w-full border px-8" defaultValue="mission">
          <AccordionItem value="mission" className="border-b border-dashed">
            <AccordionTrigger className={styles.trigger}>
              <Icon name="stash:times-circle-solid" className={cn(styles.icon.closed)} />
              <Icon name="material-symbols:check-circle-outline" className={cn(styles.icon.open)} />
              Misyonumuz
            </AccordionTrigger>
            <AccordionContent className={styles.content}>
              Uluslararası ticarette sınırları kaldırmak ve paydaşlarımıza güvenilir çözümler sunmak için çalışıyoruz. UTB Support olarak, iş ortaklarımızın ticaret süreçlerini kolaylaştırmak ve desteklemek için burada bulunuyoruz. Misyonumuz, sektördeki tüm yenilikleri takip ederek, ticaret alanında profesyonel ve çözüm odaklı bir yaklaşım sunmak. İş birliklerimizle, küresel pazarda daha güçlü bir konumda olmanızı sağlıyoruz.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="support" className="border-b border-dashed">
            <AccordionTrigger className={styles.trigger}>
              <Icon name="stash:times-circle-solid" className={cn(styles.icon.closed)} />
              <Icon name="material-symbols:check-circle-outline" className={cn(styles.icon.open)} /> Destek Almak İçin Nasıl İlerlemelisiniz?
            </AccordionTrigger>
            <AccordionContent className={styles.content}>
              Destek almak için müşteri temsilcilerimizle iletişime geçebilir veya online destek formunu doldurabilirsiniz.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="what-we-do" className="border-b border-dashed">
            <AccordionTrigger className={styles.trigger}>
              <Icon name="stash:times-circle-solid" className={cn(styles.icon.closed)} />
              <Icon name="material-symbols:check-circle-outline" className={cn(styles.icon.open)} /> Ne Yapıyoruz?
            </AccordionTrigger>
            <AccordionContent className={styles.content}>
              Uluslararası ticaret süreçlerinde danışmanlık, platform desteği ve eğitim hizmetleri sunuyoruz.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="values" className="border-none">
            <AccordionTrigger className={styles.trigger}>
              <Icon name="stash:times-circle-solid" className={cn(styles.icon.closed)} />
              <Icon name="material-symbols:check-circle-outline" className={cn(styles.icon.open)} /> Değerlerimiz
            </AccordionTrigger>
            <AccordionContent className={styles.content}>
              Güvenilirlik, şeffaflık, yenilikçilik ve müşteri odaklılık temel değerlerimizi oluşturur.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </Container>
    </section>
  )
}

export default MissionAccordion